import { requiredHeaders } from '../../../models/required-headers';
import { ignoreData } from '../../../utils/ignore-data';
import { withJwt } from '../../../utils/with-jwt';
import { fleetEnvironment } from '../fleet-environment';
import { fromFetch } from 'rxjs/fetch';

/**
 * Starts the process of Importing assets
 */
export function postCompanySyncStatus(this: unknown, syncDisabled: boolean) {
  return withJwt((jwtAuthHeaders) =>
    fromFetch(
      new Request(fleetEnvironment.resolve(this).companySyncStatusUrl, {
        method: 'POST',
        headers: {
          ...requiredHeaders,
          ...jwtAuthHeaders,
        },
        body: JSON.stringify({ syncDisabled }),
      })
    )
  ).pipe(ignoreData());
}
